import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import SetupMFAEnforced from '../../pages/SetupMFAEnforced'
import { getUser } from '../../selectors/initialization'
import { getShouldSetupMFA } from '../../selectors/settings'
import { withCenteredBaseWithMenu } from '../../components/Base'
import { setupMfa } from '../../actions/mfaSettings'
import { getRecoveryCodeError } from '../../selectors/settings'

export const mapStateToProps = createSelector(
  [getUser, getRecoveryCodeError, getShouldSetupMFA],
  (user, errorCode, shouldSetupMFA) => ({
    user,
    errorCode,
    displayLogoutMenuOnly: shouldSetupMFA
  })
)

export const mapDispatchToProps = dispatch => ({
  onSetupMfa: () => {
    dispatch(setupMfa({ isFromSettings: false }))
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withCenteredBaseWithMenu(SetupMFAEnforced))
